var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifiOneThird(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    className: "bi bi-wifi-1",
    viewBox: "0 0 16 16",
    id: "Wifi-1--Streamline-Bootstrap",
    height: 16,
    width: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Wifi 1 Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.046 10.454c0.226 -0.226 0.185 -0.605 -0.1 -0.75A6.5 6.5 0 0 0 8 9c-1.06 0 -2.062 0.254 -2.946 0.704 -0.285 0.145 -0.326 0.524 -0.1 0.75l0.015 0.015c0.16 0.16 0.407 0.19 0.611 0.09A5.5 5.5 0 0 1 8 10c0.868 0 1.69 0.201 2.42 0.56 0.203 0.1 0.45 0.07 0.611 -0.091zM9.06 12.44c0.196 -0.196 0.198 -0.52 -0.04 -0.66A2 2 0 0 0 8 11.5a2 2 0 0 0 -1.02 0.28c-0.238 0.14 -0.236 0.464 -0.04 0.66l0.706 0.706a0.5 0.5 0 0 0 0.707 0l0.708 -0.707z",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiOneThird);
export default __webpack_public_path__ + "static/media/Wifi-One-Third.d8e0f1c4fb8f0e7447844f9d1b763433.svg";
export { ForwardRef as ReactComponent };